import { render, staticRenderFns } from "./LoanFullyPaidWidget.vue?vue&type=template&id=53973fa4&scoped=true&"
import script from "./LoanFullyPaidWidget.vue?vue&type=script&lang=ts&"
export * from "./LoanFullyPaidWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53973fa4",
  null
  
)

export default component.exports